import React from 'react';

export const SvgLogout = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="25"
      height="19"
      viewBox="0 0 25 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M24.1678 10.3094L16.1674 18.3098C15.4531 19.0241 14.215 18.524 14.215 17.5002V12.9285H7.73845C7.10509 12.9285 6.59554 12.419 6.59554 11.7856V7.21396C6.59554 6.5806 7.10509 6.07105 7.73845 6.07105H14.215V1.4994C14.215 0.480297 15.4484 -0.0244897 16.1674 0.689831L24.1678 8.69023C24.6107 9.13787 24.6107 9.86172 24.1678 10.3094ZM9.64331 18.0716V16.1668C9.64331 15.8525 9.38616 15.5953 9.07185 15.5953H5.07166C4.22876 15.5953 3.54777 14.9143 3.54777 14.0714V4.92814C3.54777 4.08524 4.22876 3.40425 5.07166 3.40425H9.07185C9.38616 3.40425 9.64331 3.1471 9.64331 2.83279V0.927939C9.64331 0.613637 9.38616 0.356482 9.07185 0.356482H5.07166C2.54772 0.356482 0.5 2.4042 0.5 4.92814V14.0714C0.5 16.5954 2.54772 18.6431 5.07166 18.6431H9.07185C9.38616 18.6431 9.64331 18.3859 9.64331 18.0716Z"
        fill="currentColor"
      />
    </svg>
  );
};
